import React, { useState } from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Chip,
  Grid,
  Grid2,
  MenuItem,
  Select,
  Typography,
  useTheme,

} from "@mui/material";
import Skeleton from '@mui/material/Skeleton';

import Highcharts, { color } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useGetMachineRunHoursQuery, } from "store/slices/apis/pmDashboardSlice";
import { IoIosArrowDown } from "react-icons/io";
import { useParams } from "react-router-dom";



const MachineRunHours = () => {
  const { projectId } = useParams();
  const theme = useTheme();

  const chartData = [
    {
      label: "Yesterday",
    }
  ]



  const { data, isLoading, error } = useGetMachineRunHoursQuery({ projectId });


  const categories = data?.data.map((item) => item.label)
  const onData = data?.data.map(item => item.on) || [];
  const idleData = data?.data.map(item => item.idle) || [];
  const offData = data?.data.map(item => item.off) || [];



  const isArrayAllZero = (array) => array.every(item => item === 0);


  const isAllZero = isArrayAllZero(onData) && isArrayAllZero(idleData) && isArrayAllZero(offData);


  const chartOptions = {
    chart: {
      type: "column",
      height: 320,
    },
    title: {
      text: "",
      align: "left",
      style: {
        color: "#2D3E50",
        fontWeight: "bold",
        fontSize: "16px",
      },
    },
    xAxis: {
      categories: categories,
      tickmarkPlacement: "on",
      tickWidth: 1,
      tickLength: 10,
      tickColor: "#999",
      lineWidth: 1,
      lineColor: "#758195",
      labels: {
        style: {
          fontWeight: 500,
          fontSize: "12px",
          color: "#000000",
          opacity: 0.5,
          lineHeight: "100%",
        },
      },
    },
    yAxis: {
      min: 0,
      gridLineWidth: 1,
      tickWidth: 1,
      tickLength: 10,
      tickColor: "#999",
      lineWidth: 1,
      lineColor: "#758195",

      beginAtZero: true,
      title: {
        text: "Run Hours",
        style: {
          color: "#C05222",
          fontWeight: "500",
          fontSize: "16px",
        },
      },
      labels: {
        style: {
          fontWeight: 500,
          fontSize: "10px",
          color: "#414D55",
          opacity: 0.5,
          lineHeight: "100%",
        },
      },
    },
    legend: {
      enabled: true,
      align: "left",
      verticalAlign: "top",
      reversed: true,
      layout: "horizontal",
      itemDistance: 20,
      symbolRadius: 0,
      symbolHeight: 12,
      symbolWidth: 12,
      margin: 43,
      itemStyle: {
        fontWeight: 500,
        color: "#00000080",
        fontSize: "13px",
        mr: "2px",
        color: "#182A4E",
      },
    },

    tooltip: {
      pointFormat: "{series.name}: <b>{point.y}</b><br/>",
      shared: true,
    },
    plotOptions: {
      column: {
        // pointPadding: 0,
        borderWidth: 0,
        stacking: "normal",
        dataLabels: {
          enabled: true,
          color: "#FFFFFF",
          style: {
            fontWeight: "bold",
          },
        },
      },
    },
    credits: {
      enabled: false,
    },
    series: [
      {
        name: "ON",
        data: onData,
        color: "#2D6A4F",
        pointWidth: 70,
        borderRadiusTopLeft: 0,
        borderRadiusTopRight: 0,
        dataLabels: {
          shadow: false,
          enabled: true,
          verticalAlign: "top",
          y: 5,
          style: {
            textOutline: "none",
            fontSize: "14px",
            fontWeight: 600,
          },
        },
      },
      {
        name: "IDLE",
        data: idleData,
        pointWidth: 70,
        color: "#F9D71C",
        dataLabels: {
          enabled: true,
          verticalAlign: "top",
          y: 7,
          style: {
            textOutline: "none",
            fontSize: "14px",
            fontWeight: 600,
          },
        },
      },
      {
        name: "OFF",
        data: offData,
        pointWidth: 70,
        color: "#E72B33",
        borderRadiusBottomLeft: 0,
        borderRadiusBottomRight: 0,
        dataLabels: {
          enabled: true,
          color: "#FFFFFF",
          verticalAlign: "top",
          y: 7,
          style: {
            fontSize: "14px",
            fontWeight: 600,
            textOutline: "none",
          },
        },
      },
    ],
  };
  return (
    <Box
      sx={{
        padding: 2,
        background: "#fff",
        borderRadius: 2,
        mb: 2,
        height: "450px",
        minHeight: "100%",
        width: "100%",
      }}
    >
      <Grid2 container>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Typography
            variant="body"
            sx={{
              fontWeight: 500,
              fontSize: "18px",
              lineHeight: "100%",
              letterSpacing: "-0.4px",
              color: `${theme?.customSettings?.themeColor}`,
            }}
          >
            Machine Run Hours
          </Typography>
          <Typography
            sx={{
              mt: "5px",
              color: "#5052588A",
              fontSize: "14px",
              mb: "20px",
              lineHeight: "100%",
              letterSpacing: "-0.4px",
              whiteSpace: { xs: "normal", md: "nowrap" },
            }}
          >
            Total amount of time a machine has been operating or actively running.
          </Typography>
        </Grid2>
        {/* <Grid2 size={{ xs: 12, md: 6 }}>
          <Box sx={{ width: "100%", display: "flex", justifyContent: "end" }}>
            <Select
              labelId="demo-simple-select-standard-label"
              id="demo-simple-select-standard"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              IconComponent={IoIosArrowDown}
              sx={{
                backgroundColor: "#E8E8E8",
                "& .MuiOutlinedInput-input": {
                  padding: "5px 15px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
            >
              <MenuItem value="Hours">Hours</MenuItem>
              <MenuItem value="Percentage">Percentage</MenuItem>
            </Select>
          </Box>
        </Grid2> */}
      </Grid2>

      <Grid2 container>
        <Grid2 size={{ xs: 12, md: 12 }}>
          {isLoading ? (
            <Skeleton variant="rectangular" height={320} width="100%" />
          ) : error ? (
            <Typography color="error" sx={{ textAlign: "center", mt: 5 }}>
              Error loading data
            </Typography>
          ) : isAllZero ? (
            <Box sx={{ width: '100%', textAlign: 'center', py: 4 }}>
              <Typography variant="body1" color="textSecondary">
                No data available to display the chart.
              </Typography>
            </Box>
          )
            : (
              <HighchartsReact highcharts={Highcharts} options={chartOptions} />
            )}
        </Grid2>
      </Grid2>

    </Box>
  );
};

export default MachineRunHours;
